import { Observable } from 'rxjs';
import {
  CreateFileLibraryResponse,
  CreateFileLibraryRequest
} from '@model/laboratory/library/file-library/file-library.model';

/**
 * File Library Repository
 *
 * Defines the contract for file-based library creation operations.
 * This abstract class is defined in the domain layer and implemented in the infrastructure layer.
 */
export abstract class FileLibraryRepository {
  /**
   * Create libraries from file upload with grouped samples
   * Each group in the request becomes a separate library
   *
   * @param request - Request containing user ID and library groups with samples
   * @returns Observable with array of created library information
   */
  abstract createLibrariesFromFile(
    request: CreateFileLibraryRequest
  ): Observable<CreateFileLibraryResponse[]>;
}
